import React from "react";

import { isVoiceFirstNavigation } from "../../helpers/userPreferences";

function SettingsToggle({ label, hint, checked, onChange, disabled = false }) {
  return (
    <label
      className={`user-preferences__row${disabled ? " user-preferences__row--disabled" : ""}`}
    >
      <span>
        <span className="user-preferences__label">{label}</span>
        {hint ? <p className="user-preferences__hint">{hint}</p> : null}
      </span>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
    </label>
  );
}

export function AshleyVoiceSettingsSection({ preferences, onUpdatePreferences, saving = false }) {
  const voiceFirstNavigation = isVoiceFirstNavigation(preferences);

  return (
    <div className="user-preferences__group">
      <h3 className="user-preferences__heading">Ashley</h3>
      <SettingsToggle
        label="Voice-First Navigation"
        hint="When enabled, tapping Ashley opens the Voice Assistant and press-and-hold opens the Quick Menu. When disabled, these actions are reversed."
        checked={voiceFirstNavigation}
        disabled={saving}
        onChange={(value) =>
          onUpdatePreferences({
            ashley: { voiceFirstNavigation: value },
          })
        }
      />
    </div>
  );
}
